import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';

// pages and components
import BirdIdentifier from "./components/BirdIdentifier";
import Journal from "./components/Journal";
import Login from "./components/Login";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import Header from "./components/Header";


function App() {
  return (
    <AuthProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/identify" element={<BirdIdentifier />} />
          <Route path="/journal" element={<Journal />} />
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
